app.controller('CommonFileUploadController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const siteHelper = $rootScope.site_helper;

    $scope.file_upload_model = $scope.file_upload_model ? $scope.file_upload_model : {};

    const fileUploadModel = $scope.file_upload_model;

    let fileUploadedElement = null;

    const getConfig = (configID) => {
        switch (configID) {
            case "replacement_image":
                return {
                    accept: 'image/jpg, image/jpeg, image/png, image/gif, image/bmp',
                    upload_max_filesize: 10 * 1024 * 1024,
                    file_upload_limit: 3,
                    item_type_name: "image",
                    item_type_name_plural: "images",
                    save_endpoint: "/request/user-image-upload.php"
                };
            default:
                return {
                    upload_max_filesize: 0,
                    file_upload_limit: 0,
                    item_type_name: "file",
                    item_type_name_plural: "files",
                    final_files: [],
                    have_files: false,
                    initialized: true,
                    reset: false,
                    cleanup: false
                };
        }
    }
    const configID = fileUploadModel.config_id ? fileUploadModel.config_id : $scope.config_id;
    $scope.image_prefix = fileUploadModel.prefix ? fileUploadModel.prefix : '';
    if(configID){
        const config = getConfig(configID);
        for(let key in config){
            if(!fileUploadModel.hasOwnProperty(key)){
                fileUploadModel[key] = config[key];
            }
        }
    }
    const defaultConfig = getConfig(null);
    for(let key in defaultConfig){
        if(!fileUploadModel.hasOwnProperty(key)){
            fileUploadModel[key] = defaultConfig[key];
        }
    }
    fileUploadModel.recently_uploaded_states = [];
    fileUploadModel.uploaded_states = [];
    fileUploadModel.in_progress_states = [];
    fileUploadModel.invalid_states = [];
    fileUploadModel.upload_errors = [];

    if($rootScope.model.site.upload_max_filesize){
        fileUploadModel.upload_max_filesize = fileUploadModel.upload_max_filesize ? Math.min(fileUploadModel.upload_max_filesize, $rootScope.model.site.upload_max_filesize) : $rootScope.model.site.upload_max_filesize;
    }

    fileUploadModel.upload_max_filesize_kb = fileUploadModel.upload_max_filesize / 1024;
    fileUploadModel.upload_max_filesize_mb = fileUploadModel.upload_max_filesize_kb / 1024;
    let originalFiles = fileUploadModel.final_files.slice();

    const fileStates = [];

    $scope.itemTypeName = function (itemCount) {
        return itemCount !== 1 ? fileUploadModel.item_type_name_plural : fileUploadModel.item_type_name;
    }

    function applyCurrentFileState(){
        fileUploadModel.recently_uploaded_states.length = 0;
        fileUploadModel.uploaded_states.length = 0;
        fileUploadModel.in_progress_states.length = 0;
        fileUploadModel.invalid_states.length = 0;

        fileUploadModel.upload_errors.length = 0;
        fileUploadModel.final_files.length = 0;
        for(let i = 0; i < originalFiles.length; i ++) {
            fileUploadModel.final_files.push(originalFiles[i]);
        }


        for(let i = 0; i < fileStates.length; i ++) {
            const fileState = fileStates[i];
            fileState.current_index = i;
            if(fileState.is_error){
                fileUploadModel.invalid_states.push(fileState);
                $rootScope.site_helper.addErrorMessage(fileState.name + "\n" + fileState.message, fileUploadModel.upload_errors)
               // $rootScope.site_helper.addErrorMessage(fileState.name, fileUploadModel.upload_errors)
               // $rootScope.site_helper.addErrorMessage(fileState.message, fileUploadModel.upload_errors)
            } else if(fileState.is_loading){
                fileUploadModel.in_progress_states.push(fileState);
            } else {
                fileUploadModel.uploaded_states.push(fileState);
                if(!fileState.prevously_uploaded){
                    fileUploadModel.recently_uploaded_states.push(fileState);
                }
                fileUploadModel.final_files.push(fileState.url)
            }
        }

        fileUploadModel.have_files = fileUploadModel.final_files.length ? '1' : '';
    }

    function cleanupFilesStates(){
        for(let i = 0; i < fileStates.length; i ++){
            let fileState = fileStates[i];
            if(fileState.is_error){
                fileStates.splice(i, 1);
                i --;
            }
            if(fileState.url){
                fileState.prevously_uploaded = true;
            }
        }
        applyCurrentFileState();
    }

    function resetFilesStates(){
        fileStates.length = 0;
        if(fileUploadedElement){
            fileUploadedElement.value = "";
        }
        cleanupFilesStates();
    }

    $scope.checkUploadState = function () {
        if(fileUploadModel.reset){
            fileUploadModel.reset = false;
            fileUploadModel.cleanup = false;
            resetFilesStates();
        } else if(fileUploadModel.cleanup){
            fileUploadModel.cleanup = false;
            cleanupFilesStates();
        }
    }

    $scope.deleteFile = function (index) {
        fileStates.splice(index, 1);

        cleanupFilesStates();
    }

    $scope.onSelectFileClicked = function (target) {
        fileUploadedElement = target;
        if(fileUploadModel.file_upload_limit !== 1){
            target.setAttribute("multiple", "1");
        }
        target.value = "";
        $scope.$apply();
    }

    $scope.onFilesSelected = function (target, tst) {

        cleanupFilesStates();
        let imagePrefix = target.getAttribute("data-image-prefix");
        imagePrefix = imagePrefix? imagePrefix : "";

        let fileCount = 0;
        for(let i = 0; i < fileStates.length; i ++) {
            let fileState = fileStates[i];
            if(fileState.url){
                fileCount ++;
            }
        }

        const uploadMaxFilesize = fileUploadModel.upload_max_filesize;

        let formData = null;
        const responseFilesStates = [];
        for(let i = 0; i < target.files.length; i ++) {
            const file = target.files[i];
            let originalFileName = (file.name ? file.name : "File " + (i + 1));
            let parts = originalFileName.split(".");
            let baseName = parts[0] && siteHelper.alphaNumeric(parts[0]) ? siteHelper.alphaNumeric(parts[0]) : "file";
            let ext = parts[1] ? parts[1] : "ext";
            let fileName = imagePrefix + "image-" + i + "-" + baseName + "." + ext;
            const fileSize = file.size ? parseInt(file.size) : 0;

            let errorMessage = null;
            if(!fileSize) {
                errorMessage = "Could not process file";
            } else if(uploadMaxFilesize && fileSize > uploadMaxFilesize) {
                errorMessage = "Max file size ("+siteHelper.numberWithCommas(fileUploadModel.upload_max_filesize_kb)+" kb) exceeded. Selected file size is "+siteHelper.numberWithCommas(Math.ceil(fileSize / 1024)+" kb");
            } else if(fileUploadModel.file_upload_limit && fileCount >= fileUploadModel.file_upload_limit){
                errorMessage = "A maximum of " + fileUploadModel.file_upload_limit + " " +(fileUploadModel.file_upload_limit !== 1 ? "s" : "") + " can  be uploaded";
            }

            let fileState = {
                name: originalFileName
            };
            if(errorMessage){
                fileState.is_error = true;
                fileState.message = errorMessage;
            } else {
                fileState.is_loading = true;
                formData = formData ? formData :  new FormData();
                formData.append("file"+i, file, fileName);
                responseFilesStates.push(fileState);
                fileCount ++;
            }
            fileStates.push(fileState)
        }

        if(formData){

            $rootScope.service.request.uploadFileRequest(fileUploadModel.save_endpoint, formData, (success, data, messages) => {
                if(!data || !Array.isArray(data)){
                    success = false;
                    data = [];
                }
                const defaultErrorMessage = !success && messages && messages.length ? messages[0].msg : null;
                for(let i = 0; i < responseFilesStates.length; i ++){
                    const fileState = responseFilesStates[i];
                    fileState.is_loading = false;
                    const correspondingState = data[i];
                    const isError = !correspondingState || correspondingState.is_error || !correspondingState.url;
                    if(isError){
                        fileState.is_error = true;
                        fileState.message = correspondingState && correspondingState.message ? correspondingState.message : defaultErrorMessage;
                    } else {
                        fileState.url = correspondingState.url;
                    }
                }

                applyCurrentFileState();
                setTimeout(() => {
                    $scope.$apply();
                }, 1)
            })
        }

        applyCurrentFileState();

        $scope.$apply();
    }
    cleanupFilesStates();


}]);